import WhiteLabelThemeProvider from '@/configuration/components/WhiteLabelThemeProvider/WhiteLabelThemeProvider'

import * as Styles from './styles'

const MiscCardPreview = ({ children }) => (
  <Styles.Container>
    <WhiteLabelThemeProvider>
      <Styles.PreviewContent>
        <Styles.MiscCardsContainer>{children}</Styles.MiscCardsContainer>
      </Styles.PreviewContent>
    </WhiteLabelThemeProvider>
  </Styles.Container>
)

export default MiscCardPreview
